import {ChangeDetectionStrategy, Component, Input, OnChanges} from '@angular/core';
import {highlightSearchText, SearchHighlightSegment} from '../../search/search-highlight';

@Component({
  selector: 'sm-search-highlight',
  templateUrl: './sm-search-highlight.component.html',
  styleUrls: ['./sm-search-highlight.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmSearchHighlightComponent implements OnChanges {
  @Input() text = '';
  @Input() query = '';
  @Input() context = false;

  segments: SearchHighlightSegment[] = [];

  ngOnChanges(): void {
    this.segments = highlightSearchText(this.text, this.query, this.context);
  }
}
